<template>
  <div class="service">
    <Header></Header>
    <div class="banner-img">
      <div class="flex-col banner-title container">
        <p class="main-title">全流程服务</p>
        <p class="sub-title">
          中产集团数智化招商方式、全流程服务，直通项目落地最后一公里。
        </p>
      </div>
    </div>
    <div class="flex-row service-list-lr">
      <div class="left flex-col">
        <p class="flex-row">
          <img src="@/assets/images/service/ts-jiantou-right.png" alt="" />
          <span>项目筛选</span>
        </p>
        <p
          class="service-item flex-col wow animate__animated animate__fadeInUp"
          data-wow-delay=".1s"
          data-wow-offset="10"
        >
          项目和基金团队对有意向投资项目方进行专业筛选、评估、背景调查等工作，包含但不限于投资强度、税收强度、环评环保、技术专利、运营团队、资金来源、企业诚信度、法律纠纷、政策要求等。通过筛选后的项目才能入库。
        </p>
      </div>
      <div class="right">
        <img src="@/assets/images/service/service1.jpg" alt="" />
      </div>
    </div>
    <div class="flex-row service-list-rl">
      <div class="left">
        <img src="@/assets/images/service/service2.jpg" alt="" />
      </div>
      <div class="right flex-col">
        <p class="flex-row">
          <img src="@/assets/images/service/jiantou-right.png" alt="" />
          <span>项目对接</span>
        </p>
        <p
          class="service-item flex-col wow animate__animated animate__fadeInUp"
          data-wow-delay=".1s"
          data-wow-offset="10"
        >
          筛选并经中产集团考察后的项目，与政府园区进行充分沟通确认，双方满意后，安排“一对一”精准项目对接会。
        </p>
      </div>
    </div>
    <div class="flex-row service-list-lr">
      <div class="left flex-col">
        <p class="flex-row">
          <img src="@/assets/images/service/ts-jiantou-right.png" alt="" />
          <span>项目考察</span>
        </p>
        <p
          class="service-item flex-col wow animate__animated animate__fadeInUp"
          data-wow-delay=".1s"
          data-wow-offset="10"
        >
          对接满意后，安排政企进行双向考察，并深度洽谈落地合作细节。中产集团利用旗下中产智库优势，协助政府对于相关企业的需求进行政策制定、落实。
        </p>
      </div>
      <div class="right">
        <img src="@/assets/images/service/service3.jpg" alt="" />
      </div>
    </div>
    <div class="flex-row service-list-rl">
      <div class="left">
        <img src="@/assets/images/service/service4.jpg" alt="" />
      </div>
      <div class="right flex-col">
        <p class="flex-row">
          <img src="@/assets/images/service/jiantou-right.png" alt="" />
          <span>项目签约</span>
        </p>
        <p
          class="service-item flex-col wow animate__animated animate__fadeInUp"
          data-wow-delay=".1s"
          data-wow-offset="10"
        >
          政企双方考察后，进一步达成落地意向，由中产集团合作履约团队进行协助推进项目快速落地。
        </p>
      </div>
    </div>
    <div class="flex-row service-list-lr">
      <div class="left flex-col">
        <p class="flex-row">
          <img src="@/assets/images/service/ts-jiantou-right.png" alt="" />
          <span>签约后服务</span>
        </p>
        <p
          class="service-item flex-col wow animate__animated animate__fadeInUp"
          data-wow-delay=".1s"
          data-wow-offset="10"
        >
          项目与政府签约后，针对部分优质且有资金需求的项目，中产资本可以直接、间接为企业提供资金配套服务，减轻政府财政压力，推动优质项目能够顺利竣工、达产。
        </p>
      </div>
      <div class="right">
        <img src="@/assets/images/service/service5.jpg" alt="" />
      </div>
    </div>
    <div id="progress" class="cooperation-process">
      <div class="container">
        <h1>合作流程</h1>
        <p class="desc">中产集团全程协助政企实现高效、 务实、专业对接服务，</p>
        <p class="desc">
          降低政企双方沟通成本，节约政企领导宝贵时间，提高招商引资成功率。
        </p>
        <div class="flow-process flex-row">
          <div class="flex-col item">
            <div
              class="img service-item flex-col wow animate__animated animate__rollIn"
              data-wow-delay=".1s"
              data-wow-offset="10"
            >
              对接前
            </div>
            <p>
              成立项目服务小组，分析产业需求<br />
              把关筛选要素，精选优质项目<br />
              协助政企互通，精准一对一服务
            </p>
          </div>
          <div class="left-jt">
            <img src="@/assets/images/service/right-bottom.png" alt="" />
          </div>
          <div class="flex-col item move">
            <div
              class="img service-item flex-col wow animate__animated animate__rollIn"
              data-wow-delay=".3s"
              data-wow-offset="10"
            >
              对接中
            </div>
            <p>
              专职陪同政府客户到项目方考察<br />
              深化政企对接，针对性沟通交流<br />
              政企对接满意，确认双方合作意愿
            </p>
          </div>
          <div class="left-jt">
            <img src="@/assets/images/service/right-top.png" alt="" />
          </div>
          <div class="flex-col item">
            <div
              class="img service-item flex-col wow animate__animated animate__rollIn"
              data-wow-delay=".5s"
              data-wow-offset="10"
            >
              对接后
            </div>
            <p>
              政企回访，反馈诉求，解决异议点<br />
              企业反向考察政府园区，协调落地细节
            </p>
          </div>
          <div class="left-jt">
            <img src="@/assets/images/service/right-bottom.png" alt="" />
          </div>
          <div class="flex-col item move">
            <div
              class="img service-item flex-col wow animate__animated animate__rollIn"
              data-wow-delay=".7s"
              data-wow-offset="10"
            >
              正式签约
            </div>
            <p>政企签订正式协议, 协助落实开工筹备</p>
          </div>
        </div>
      </div>
    </div>
    <div id="service-case"></div>
    <!-- 落地案例 -->
    <div class="container servive-divider">
      <el-divider content-position="center">落地案例</el-divider>
    </div>
    <div class="service-evaluate">
      <div class="container" style="position: relative">
        <img
          @click="prev('carouselCase')"
          style="left: -90px; top: 240px; position: absolute; cursor: pointer"
          src="@/assets/images/aboutUs/left-arrow.png"
          alt=""
        />
        <img
          @click="next('carouselCase')"
          style="right: -90px; top: 240px; position: absolute; cursor: pointer"
          src="@/assets/images/aboutUs/right-arrow.png"
          alt=""
        />
        <el-carousel
          ref="carouselCase"
          arrow="never"
          height="610px"
          :autoplay="false"
          indicator-position="outside"
        >
          <el-carousel-item v-for="(i, index) in caseList" :key="index">
            <div class="flex-row case-list">
              <div v-for="(j, jdx) in i" :key="jdx">
                <img :src="j.picture" alt="" />
                <p>{{ j.title }}</p>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div id="service-activity"></div>
    <div class="container servive-divider">
      <el-divider content-position="center">重磅活动</el-divider>
    </div>
    <!-- 重磅活动 -->
    <div class="service-evaluate" style="padding-bottom: 62px">
      <div class="container" style="position: relative">
        <img
          @click="prev('carouselActivity')"
          style="left: -90px; top: 240px; position: absolute; cursor: pointer"
          src="@/assets/images/aboutUs/left-arrow.png"
          alt=""
        />
        <img
          @click="next('carouselActivity')"
          style="right: -90px; top: 240px; position: absolute; cursor: pointer"
          src="@/assets/images/aboutUs/right-arrow.png"
          alt=""
        />
        <el-carousel
          ref="carouselActivity"
          arrow="never"
          height="610px"
          :autoplay="false"
          indicator-position="outside"
        >
          <el-carousel-item v-for="(i, index) in activityList" :key="index">
            <div class="flex-row case-list">
              <div v-for="(j, jdx) in i" :key="jdx">
                <img :src="j.picture" alt="" />
                <p>{{ j.title }}</p>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import "@/assets/css/service.css";
import Header from "./Header";
import Footer from "./Footer";
export default {
  name: "Service",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      caseList: [
        [
          {
            imgSrc: require("@/assets/images/service/case1.jpg"),
            word: "山东枣庄市台儿庄区-高品质锂离子电芯扩建项目",
          },
          {
            imgSrc: require("@/assets/images/service/case2.jpg"),
            word: "山西省芮城县风陵渡经济开发区-品牌锂电池负极材料项目",
          },
          {
            imgSrc: require("@/assets/images/service/case3.jpg"),
            word: "山东某合作政府-动力电池新建基地项目",
          },
          {
            imgSrc: require("@/assets/images/service/case4.jpg"),
            word: "江西新余高新区-新能源专用车项目",
          },
          {
            imgSrc: require("@/assets/images/service/case5.jpg"),
            word: "黑龙江省哈尔滨市巴彦县-品牌饲料企业布局扩产项目",
          },
          {
            imgSrc: require("@/assets/images/service/case6.jpg"),
            word: "辽宁省本溪市南芬区-主板上市光伏玻璃生产基地项目",
          },
        ],
        [
          {
            imgSrc: require("@/assets/images/service/case7.jpg"),
            word: "山东临沂兰陵经开区-尖端LED灯具生产基地项目",
          },
          {
            imgSrc: require("@/assets/images/service/case8.jpg"),
            word: "新疆昌吉国家农业科技园区-生物新材料生产基地扩建项目",
          },
          {
            imgSrc: require("@/assets/images/service/case9.jpg"),
            word: "重庆万州-新一代信息技术产品生产项目",
          },
          {
            imgSrc: require("@/assets/images/service/case10.jpg"),
            word: "江西省抚州市乐安县-动力锂电池生产基地项目",
          },
          {
            imgSrc: require("@/assets/images/service/case11.jpg"),
            word: "四川省眉山市仁寿县-3D裸眼产品扩建项目",
          },
          {
            imgSrc: require("@/assets/images/service/case12.jpg"),
            word: "山西长治武乡县-年产15万吨石墨负极材料全产业链及1万吨硅基负极材料项目",
          },
        ],
        [
          {
            imgSrc: require("@/assets/images/service/case13.jpg"),
            word: "新疆昌吉国家农业科技园区-新一代智能化农业装备制造基地项目",
          },
          {
            imgSrc: require("@/assets/images/service/case14.jpg"),
            word: "陕西省安康市石泉县-智能电子显示屏项目",
          },
          {
            imgSrc: require("@/assets/images/service/case15.jpg"),
            word: "江西省鹰潭市贵溪市-OLED有机发光材料生产项目",
          },
        ],
      ],
      activityList: [
        [
          {
            imgSrc: require("@/assets/images/service/activity1.jpg"),
            word: "2022.02.24 “唯爱伴我行，上海市住院医师科普月月讲”2021年颁奖大会",
          },
          {
            imgSrc: require("@/assets/images/service/activity2.jpg"),
            word: "2021.12.23 上海市第五届“产融荟”项目投融资对接会“金融服务专精特新企业”",
          },
          {
            imgSrc: require("@/assets/images/service/activity3.jpg"),
            word: "2021.11.28 “托尼诺·莫利奇：意出象外”艺术展开幕式暨上海星动力星联会VIP尊享晚宴",
          },
          {
            imgSrc: require("@/assets/images/service/activity4.jpg"),
            word: "2021.10.30 2021上海杉树迎新大会暨公益第十期导师计划启动仪式",
          },
          {
            imgSrc: require("@/assets/images/service/activity5.jpg"),
            word: "2021.10.26 “未来教育论坛，新父母的VUCA时代”中欧校友父母教育论坛",
          },
          {
            imgSrc: require("@/assets/images/service/activity6.jpg"),
            word: "2021.08.28 企业思想家年中闭门论道交流会",
          },
        ],
        [
          {
            imgSrc: require("@/assets/images/service/activity7.jpg"),
            word: "2021.05.25 工经联产融荟第二次投融资对接会2",
          },
          {
            imgSrc: require("@/assets/images/service/activity8.jpg"),
            word: "2021.05.25 工经联产融荟第二次投融资对接会1",
          },
          {
            imgSrc: require("@/assets/images/service/activity9.jpg"),
            word: "2019.11.05 宿州经开区（上海）生物医药产业发展交流会暨招商推介会",
          },
          {
            imgSrc: require("@/assets/images/service/activity10.jpg"),
            word: "2019.11.05 ‘携手惠州·启航湾区’惠州市投资环境推介会——电子信息产业专场",
          },
          {
            imgSrc: require("@/assets/images/service/activity11.jpg"),
            word: "2018.11.08 吉林省建设开放合作高地跨国公司恳谈会",
          },
          {
            imgSrc: require("@/assets/images/service/activity12.jpg"),
            word: "2018.08.18 中国-欧洲上海合作论坛",
          },
        ],
        [
          {
            imgSrc: require("@/assets/images/service/activity13.jpg"),
            word: "2018.08.06 国家商务部“一带一路”阿拉伯国家中小企业商务官员交流会",
          },
          {
            imgSrc: require("@/assets/images/service/activity14.jpg"),
            word: "2018.08.04 全球区块链创新50强",
          },
          {
            imgSrc: require("@/assets/images/service/activity15.jpg"),
            word: "2018.04.22 联合国工业发展组织上海国际智能制造促进中心落户上海星动力",
          },
          {
            imgSrc: require("@/assets/images/service/activity16.jpg"),
            word: "2017.11.06 中国—东盟数字经济发展与合作研讨会",
          },
          {
            imgSrc: require("@/assets/images/service/activity17.jpg"),
            word: "2017.09.22 “一带一路”产业合作交流会",
          },
          {
            imgSrc: require("@/assets/images/service/activity18.jpg"),
            word: "2017.08.16 首届国际科创园区（上海）博览会",
          },
        ],
        // [
        //   { imgSrc: require("@/assets/images/service/activity19.jpg"), word: "2017.08.11 诺贝尔奖得主产业合作峰会" },
        // ]
      ],
    };
  },
  mounted() {
    var wow = new this.$wow.WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 200,
      mobile: false,
      live: true,
    });
    wow.init();
    this.getCaseList();
    this.getActivityList();
  },
  methods: {
    prev(str) {
      this.$refs[str].prev();
    },
    next(str) {
      this.$refs[str].next();
    },
    getCaseList() {
      //落地案例
      this.Axios.post(`/api/index/cms/activity/list`, {
        type: "落地案例",
      }).then((res) => {
        this.caseList = this.$lodash.chunk(res.data.data, 6);
      });
    },
    getActivityList() {
      //重磅活动
      this.Axios.post(`/api/index/cms/activity/list`, {
        type: "重磅活动",
      }).then((res) => {
        this.activityList = this.$lodash.chunk(res.data.data, 6);
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Service.vue